<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div class="line d-flex align-items-start justify-content-between i-py-4">
    <div
      class="label d-flex align-items-start i-text-body-3 i-text-neutral-110"
    >
      {{ title }}
    </div>
    <div class="value i-text-subheading-3 i-text-neutral-120">
      <slot name="value"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.line {
  width: 100%;
  border-bottom: 1px solid transparent;

  &:not(:last-of-type) {
    border-bottom: 1px solid $light-neutral-60;
  }

  .value {
    max-width: 280px;
    text-align: right;

    a,
    .link {
      color: $light-primary-110;
    }
  }
}
</style>
